<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <!-- <div slot="header">
        <span>1. 填写学习班类型</span>
      </div>-->
      <div class="form_box__container">
        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">姓名：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="name" placeholder="请输入姓名"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item">
            <div class="form_box__group__item__title">手机号：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="phone" placeholder="请输入手机号"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">身份证：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="idcard" placeholder="请输入身份证"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item">
            <div class="form_box__group__item__title">
              <!-- 所属党组织： -->
            </div>
            <div class="form_box__group__item__content">
              <!-- <el-input v-model="phone" placeholder="请输入手机号"></el-input> -->
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">所属单位：</div>
            <div class="form_box__group__item__content">
              <ClassUnitSelect
                :showtitle="false"
                ref="ClassUnitSelect"
                :size="'large'"
                @onValueChanged="OnUnitSelectValueChanged"
              ></ClassUnitSelect>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">所属党组织：</div>
            <div class="form_box__group__item__content">
              <PartyOrgSelect
                :showtitle="false"
                ref="PartyOrgSelect"
                :size="'large'"
                @onValueChanged="OnPartySelectValueChanged"
              ></PartyOrgSelect>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">党内职务：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="partyjob" placeholder="请输入党内职务"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item">
            <div class="form_box__group__item__title">行政职务：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="adminjob" placeholder="请输入行政职务"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="save">保存</el-button>
      <!-- <el-button style="margin-top: 12px;" type="info" @click="temporaty">暂存</el-button> -->
    </el-card>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { saveApi } from "@/api/module/user/user";
import { PartyOrgSelect } from "@/views/module/partyOrganization/components";
import { ClassUnitSelect } from "@/views/module/classunit/components";

export default {
  name: "UserAdd",
  
  mixins: [BaseVue],
  
  components: {
    PartyOrgSelect,
    ClassUnitSelect
  },
  
  data() {
    return {
      name: "",
      phone: "",
      idcard: "",
      unitid: "",
      partyid: "",
      partyjob: "",
      adminjob: "",
      loading: false,
      status: ""
    };
  },
  
  methods: {
    save() {
      if (!this.name) {
        this.$message.error("请输入学员姓名！");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message.error("手机号码有误，请重填！");
        return false;
      }
      if (!this.idcard) {
        this.$message.error("请输入学员身份证！");
        return false;
      }
      if (!this.idcard) {
        this.$message.error("请输入学员身份证！");
        return false;
      }
      if (!this.unitid) {
        this.$message.error("请选择所属单位！");
        return false;
      }
      if (!this.partyid) {
        this.$message.error("请选择所属党组织！");
        return false;
      }
      if (!this.partyjob) {
        this.$message.error("请输入党内职位！");
        return false;
      }
      if (!this.adminjob) {
        this.$message.error("请输入行政职务！");
        return false;
      }

      this.loading = true;

      const data = {
        name: this.name,
        phone: this.phone,
        idcard: this.idcard,
        unitid: this.unitid,
        partyid: this.partyid,
        partyjob: this.partyjob,
        adminjob: this.adminjob
      };

      saveApi(data)
        .then(response => {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          this.init();
        });
    },
    
    init() {
      this.name = "";
      this.phone = "";
      this.idcard = "";
      this.unitid = "";
      this.partyid = "";
      this.partyjob = "";
      this.adminjob = "";
      this.$refs.ClassUnitSelect.init();
      this.$refs.PartyOrgSelect.init();
    },
    
    OnUnitSelectValueChanged(unitid) {
      this.unitid = unitid;
    },
    
    OnPartySelectValueChanged(partyid) {
      this.partyid = partyid;
    }
  },
  
  mounted() {
    // 挂载后的逻辑
  }
};
</script>

<style scoped>
</style>

